/*
 * Jira Ticket:
 * revoked Date: Mon, 20th Apr 2020, 15:01:34 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const revokeSubcontractMutation = gql`
  mutation revokeSubcontract($id: ID!) {
    data: revokeSubcontract(id: $id) {
      id
    }
  }
`;

export default ({ client, params }) => {
  try {
    return client.mutate({
      mutation: revokeSubcontractMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
